import styled from "styled-components";
import { Link as Rota } from "react-router-dom";

export const Indaituba = styled.div`
  img {
    width: 360px;
    height: 80px;
    margin-top: 30px;
    object-fit: contain;
    @media (max-width: 920px) {
      width: 315px;
      height: 80px;
    }

    @media (max-width: 660px) {
      margin-top: 35px;
      width: 210px;
      height: 50px;
    }
  }
`;

export const Fiec = styled.div`
  img {
    width: 280px;
    height: 156px;

    object-fit: contain;
    @media (max-width: 920px) {
      /* margin-top: 20px; */
      width: 180px;
      height: 104px;
    }

    @media (max-width: 660px) {
      width: 128px;
      height: 77px;
    }
  }
`;
export const Logos = styled.div`
  display: flex;
  margin-top: 20px;
  justify-content: space-around;
  width: 100%;

  @media (max-width: 420px) {
    flex-direction: column;
    justify-content: none;
    align-items: center;
    margin-top: 10px;
  }
  @media (max-width: 305px) {
    margin-top: -20px;
  }
`;

export const Titulo = styled.h1`
  text-align: center;
  margin-top: 10px;
  font-weight: bolder;
`;

export const P = styled.p`
  text-align: center;
  font-weight: bolder;
  font-size: 20px;
`;
export const H2 = styled.h2`
  margin: 0;
  color: red;
  text-align: center;
  font-size: 25px;
  font-weight: bolder;
`;

export const ConfirmCadastro = styled.div`
  padding-top: 10px;
  text-align: center;
  width: 100%;
  cursor: pointer;

  @media (max-width: 920px) {
    padding-top: 90px;
  }

  @media (max-width: 420px) {
    padding-top: 25px;
  }
`;

export const Link = styled(Rota)`
  text-decoration: underline;
  color: red;
  text-align: center;
  font-size: 30px;
  font-weight: bolder;
  transition: 0.2s linear;

  a:link,
  a:visited,
  a:active {
    text-decoration: none;
  }
  a:hover {
    color: red;
    font-size: 107%;
    transition: 0.2s linear;
  }

  &:hover {
    color: red;
  }
`;
export const Doador = styled.div`
  margin-top: 2%;
  width: 100%;
  text-align: center;

  @media (max-width: 775px) {
    display: flex;
    justify-content: space-between;
  }

  a {
    font-size: 20px;
    cursor: pointer;
    padding: 0px 0px 0px 45px;
    margin-left: -5px;

    @media (max-width: 775px) {
      padding: 0px 0px 0px 20px;
      margin-left: 0px;
    }
  }
`;

export const ContainerWhatsApp = styled.div`
  width: 100%;
  height: 150px;

  margin: 10px 0px 0px 0px;
  padding: 0 10px;

  display: flex;
  flex-direction: row;

  align-items: center;
  justify-content: center;

  gap: 15px;

  p {
    height: fit-content;
    margin: auto 0;

    max-width: 250px;
    font-size: 1rem;
    font-weight: bold;
    text-align: justify;
  }

  img {
    height: 100%;
  }

  @media (max-width: 420px) {
    height: 100px;
    font-size: 0.85rem;
    line-height: 1.125rem;
  }
`;
